import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_SUBEVENT = gql`
  mutation upsertOneSubEvent($query: SubEventQueryInput!, $data: SubEventInsertInput!) {
    result: upsertOneSubEvent(query: $query, data: $data) {
      value {
        _id
      }
    }
  }
`;

export const DELETE_SUBEVENTS = gql`
  mutation deleteManySubEvents($ids: [String!]!) {
    deleteManySubEvents(ids: $ids) {
      deletedCount
    }
  }
`;

export const GET_SUBEVENT = gql`
  query subEvent($_id: String!) {
    subEvent(_id: $_id) {
      _id
      name
      shortName
      startAt
      endAt
      enableCheckOut
      enableWalletPass
      locationLatitude
      locationLongitude
      locationFormattedAddress
      pushCrmTargetList
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      timezone {
        _id
        name
      }
      coverImage {
        unsplashId
        unsplashLink
        unsplashUserName
        unsplashUserUrl
        urlFull
        urlRegular
      }
    }
  }
`;

export const GET_SUBEVENTS = gql`
  query subEvents(
    $limit: Int
    $offset: Int
    $orderBy: [SubEventOrderByExp!] = { name: ASC }
    $where: SubEventBoolExp!
  ) {
    subEvents(limit: $limit, offset: $offset, order_by: $orderBy, where: $where) {
      _id
      name
      shortName
      startAt
      endAt
      enableCheckOut
      enableWalletPass
      locationLatitude
      locationLongitude
      locationFormattedAddress
      pushCrmTargetList
      createdAt
      createdBy
      timezone {
        _id
        name
      }
      coverImage {
        unsplashId
        unsplashLink
        unsplashUserName
        unsplashUserUrl
        urlFull
        urlRegular
      }
    }
  }
`;

export const GET_SUBEVENTS_FILTERS = gql`
  query subEvents($where: SubEventBoolExp!) {
    subEvents(order_by: { shortName: ASC }, where: $where) {
      _id
      shortName
    }
  }
`;

export const GET_SUBEVENTS_GLOBAL = gql`
  query subEvents($where: SubEventBoolExp!) {
    subEvents(order_by: { shortName: ASC }, where: $where) {
      _id
      masterEventId
      shortName
    }
  }
`;
